import { motion } from 'framer-motion';
import { AnimatedComponent } from '../AnimationPresence/AnimationPresence';

export function AnimatedCheck({ isOpen }: { isOpen: boolean }) {
  return (
    <AnimatedComponent>
      {isOpen && (
        // biome-ignore lint/a11y/noSvgWithoutTitle: <disabled>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
          strokeWidth={1.5}
          stroke='currentColor'
          className='w-4 h-4'
        >
          <motion.path
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            exit={{ pathLength: 0 }}
            transition={{
              type: 'tween',
              duration: 0.3,
              ease: isOpen ? 'easeOut' : 'easeIn',
            }}
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M4.5 12.75l6 6 9-13.5'
          />
        </svg>
      )}
    </AnimatedComponent>
  );
}
